__turbopack_context__.v({
  "active": "growingArrowButton-module-scss-module__AbSOQG__active",
  "growingArrowButton": "growingArrowButton-module-scss-module__AbSOQG__growingArrowButton",
  "growingArrowIcon": "growingArrowButton-module-scss-module__AbSOQG__growingArrowIcon",
});
